<ds-input [label]="label | translate" data-test-id="websites-apps-select" [state]="state">
  <select
    ds-input-field
    #webAppSelect
    [(ngModel)]="selectedWebApp"
    (ngModelChange)="selectWebAppChanged($event)"
    [ds-tooltip]="selectWebAppTooltip"
  >
    @for (digitalProperty of digitalProperties$ | async; track digitalProperty[$digitalProperty._id]) {
      <option [ngValue]="digitalProperty[$digitalProperty._id]">
        {{ digitalProperty[$digitalProperty.name] }}
      </option>
    }
    <hr />
    <option #webAppSelectPortfolioOption [ngValue]="portfolioValue">
      {{ 'website_and_app_portfolio_label' | translate }}
    </option>
  </select>
</ds-input>
